import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { ShieldAlert, ShieldCheck } from "lucide-react";

// Shared visual for an order's insurance choice (insurance_option: owner_risk | carrier_insurance).
// Distinct colour per option (owner = amber/warning, carrier = emerald/safe) + a hover tooltip
// explaining what each means. Used in the B2B order lists (admin + seller).
const META = {
  owner_risk: {
    label: "Owner Risk",
    Icon: ShieldAlert,
    cls: "bg-amber-50 text-amber-700 border-amber-200",
    tip: "On selecting this option, the shipment will be shipped on owner's risk, with no insurance applicable from Carrier's end.",
  },
  carrier_insurance: {
    label: "Carrier Risk",
    Icon: ShieldCheck,
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
    tip: "Insurance will be applicable as per your agreement with the insurance provider.",
  },
};

export default function InsuranceBadge({ value, className = "" }) {
  const meta = META[value];
  if (!meta) return null;
  const { label, Icon, cls, tip } = meta;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium cursor-help ${cls} ${className}`}
          >
            <Icon className="w-3 h-3 flex-shrink-0" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed">{tip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
